/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiSanctionFilter
 */
export interface ApiSanctionFilter {
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionFilter
     */
    matchField: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionFilter
     */
    inputData: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionFilter
     */
    matchData: string;
}

/**
 * Check if a given object implements the ApiSanctionFilter interface.
 */
export function instanceOfApiSanctionFilter(value: object): value is ApiSanctionFilter {
    if (!('matchField' in value) || value['matchField'] === undefined) return false;
    if (!('inputData' in value) || value['inputData'] === undefined) return false;
    if (!('matchData' in value) || value['matchData'] === undefined) return false;
    return true;
}

export function ApiSanctionFilterFromJSON(json: any): ApiSanctionFilter {
    return ApiSanctionFilterFromJSONTyped(json, false);
}

export function ApiSanctionFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'matchField': json['matchField'],
        'inputData': json['inputData'],
        'matchData': json['matchData'],
    };
}

export function ApiSanctionFilterToJSON(json: any): ApiSanctionFilter {
    return ApiSanctionFilterToJSONTyped(json, false);
}

export function ApiSanctionFilterToJSONTyped(value?: ApiSanctionFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchField': value['matchField'],
        'inputData': value['inputData'],
        'matchData': value['matchData'],
    };
}

